import React from "react";
import { NavLink } from "react-router-dom";
import HandoffHealthBadge from "./HandoffHealthBadge";

const tabClass = ({ isActive }) =>
    `font-label text-[10px] tracking-[0.25em] uppercase pb-2 border-b transition-colors duration-300 ${
        isActive
            ? "text-[#cfa052] border-[#cfa052]"
            : "text-[#9a958a] border-transparent hover:text-[#e8e4db]"
    }`;

/**
 * Sub-navigation between admin sections. Used at the top of every /admin/* page.
 * Includes a small 24h Hub-handoff health pill on the right so the Curator
 * sees integration status at a glance, without drilling in.
 */
export default function AdminSubNav() {
    return (
        <nav
            className="flex items-center gap-10 border-b border-white/5 mb-10"
            data-testid="admin-subnav"
        >
            <NavLink to="/admin"         end className={tabClass} data-testid="admin-tab-artwork">Artwork</NavLink>
            <NavLink to="/admin/batch"       className={tabClass} data-testid="admin-tab-batch">Batch</NavLink>
            <NavLink to="/admin/contact"     className={tabClass} data-testid="admin-tab-contact">Messages</NavLink>
            <NavLink to="/admin/audit"       className={tabClass} data-testid="admin-tab-audit">Audit</NavLink>
            <NavLink to="/admin/emails"      className={tabClass} data-testid="admin-tab-emails">Emails</NavLink>
            <NavLink to="/admin/handoff"     className={tabClass} data-testid="admin-tab-handoff">Handoff</NavLink>
            <NavLink to="/admin/popularity"  className={tabClass} data-testid="admin-tab-popularity">Popularity</NavLink>
            <NavLink to="/admin/attributes"  className={tabClass} data-testid="admin-tab-attributes">Attributes</NavLink>
            <NavLink to="/admin/members"     className={tabClass} data-testid="admin-tab-members">Members</NavLink>
            <NavLink to="/admin/health"      className={tabClass} data-testid="admin-tab-health">Health</NavLink>
            <NavLink to="/admin/security"    className={tabClass} data-testid="admin-tab-security">Security</NavLink>
            <HandoffHealthBadge />
        </nav>
    );
}
